import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useConsent } from '../../context/ConsentContext';
import { setMetaMarketingConsent, trackMetaPageView } from '../../utils/metaPixel';

/**
 * Loads Meta Pixel only when marketing consent is granted (prod + REACT_APP_META_PIXEL_ID).
 * Tracks PageView on SPA route changes.
 */
const MetaPixel: React.FC = () => {
  const { marketing } = useConsent();
  const location = useLocation();
  const isFirstPageView = useRef(true);

  useEffect(() => {
    setMetaMarketingConsent(marketing);
  }, [marketing]);

  useEffect(() => {
    if (!marketing) return;

    if (isFirstPageView.current) {
      isFirstPageView.current = false;
      return;
    }

    trackMetaPageView();
  }, [location.pathname, location.search, marketing]);

  return null;
};

export default MetaPixel;
